import React, { Component } from "react";
import Character from "./Character.jsx";
import { Link } from "react-router-dom";

import "./Landing.scss";

import ChooseCharacter from "../Menu/ChooseCharacter";
import RNZLogo from "./RNZLogo";
import NZOALogo from "./NZOALogo";

import Mute from "../Video/Mute";

import Mike from "../../assets/mike.png";
import Lorii from "../../assets/lorii.png";
import Humphrey from "../../assets/humphrey.png";

import { audioPaths } from "../../utils/mediaManager";

let nav = null;

let audioList = new Array();
let loopTrack = null;
let mouseOverAudio = null;
let mouseOutAudio = null;
let selectAudio = null;

class Landing extends Component {
  constructor() {
    super();
    this.state = {
      audioEnabled: false,
      playPrompt: false,
      muteState: false,
    };
  }

  componentDidMount() {
    this.props.updateNav("null");
    nav = document.getElementById("nav-bar");
    if (nav) {
      nav.classList.add("light");
      nav.classList.add("landing-nav");
    }

    loopTrack = new Audio(audioPaths("HomePageMusicBed.mp3"));
    loopTrack.volume = 0.4;
    this.controlPlayState(loopTrack);
    loopTrack.addEventListener(
      "ended",
      function () {
        console.log("looped");
        this.currentTime = 0;
        this.play();
      },
      false
    );
    audioList.push(loopTrack);

    mouseOverAudio = new Audio(audioPaths("RollOnHover.mp3"));
    mouseOutAudio = new Audio(audioPaths("RollOutOfHover.mp3"));
    selectAudio = new Audio(audioPaths("gameplan/ManSpinSwoosh.mp3"));
    audioList.push(mouseOverAudio);
    audioList.push(mouseOutAudio);
    audioList.push(selectAudio);
  }

  componentWillUnmount() {
    audioList.map((audio) => {
      audio.muted = true;
      audio.pause();
    });

    if (nav) {
      nav.classList.remove("landing-nav");
    }
  }

  unmute = () => {
    this.controlPlayState(loopTrack);
  };

  muteToggle = () => {
    console.log("mute toggle");
    this.setState({ muteState: !this.state.muteState });
    // Now mute or unmute all audio on this page
    audioList.map((audio) => {
      audio.muted = !this.state.muteState;
    });
  };

  controlPlayState = (audio) => {
    if (audio.paused) {
      var promise = audio.play();
      if (promise !== undefined) {
        promise
          .then((_) => {
            // Autoplay started!
            this.setState({ audioEnabled: true, playPrompt: false });
            console.log("autoplay");
          })
          .catch((error) => {
            // Show a button on the video saying pres play to start
            this.setState({ playPrompt: true });
          });
      }
    } else {
      audio.pause();
      this.setState({ audioEnabled: false });
    }
  };

  playMouseOverAudio = () => {
    mouseOverAudio.pause();
    mouseOverAudio.currentTime = 0;
    this.controlPlayState(mouseOverAudio);
  };

  playMouseOutAudio = () => {
    mouseOutAudio.pause();
    mouseOutAudio.currentTime = 0;
    this.controlPlayState(mouseOutAudio);
  };

  playSelectAudio = () => {
    this.controlPlayState(selectAudio);
  };

  render() {
    return (
      <div className="landing" id="landing">
        <div className="mute-toggle" onClick={this.muteToggle}>
          <Mute mode={this.state.muteState ? "mute-off" : "mute-on"} />
        </div>
        <div className="wrap">
          <RNZLogo />
          <NZOALogo />
          <div className="heading">
            <h1>
              <svg
                width="371px"
                height="111px"
                viewBox="0 0 371 111"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                id="gamechange-stacked"
              >
                <g
                  id="exports"
                  stroke="none"
                  strokeWidth="1"
                  fill="none"
                  fillRule="evenodd"
                >
                  <g
                    id="Desktop-HD"
                    transform="translate(-689.000000, -302.000000)"
                    fillRule="nonzero"
                    stroke="#FFFFFF"
                    strokeWidth="2"
                  >
                    <path d="M778.164993,352.040824 C785.858614,352.040824 791.791296,349.871098 795.963041,345.531644 L795.963041,345.531644 L795.963041,350.500004 L806.434331,350.500004 L806.434331,324.872073 L779.32847,324.872073 L779.32847,334.400003 L789.956986,334.400003 C789.956986,334.882164 789.752592,335.432457 789.343803,336.050882 C788.935014,336.669306 788.300866,337.334899 787.441361,338.047659 C786.581856,338.76042 785.345007,339.35264 783.730814,339.82432 C782.116621,340.295999 780.261348,340.531839 778.164993,340.531839 C773.364342,340.531839 769.774335,339.415531 767.394973,337.182913 C765.015611,334.950296 763.82593,331.727151 763.82593,327.513479 C763.82593,323.509442 764.994647,320.41732 767.332082,318.237111 C769.669517,316.056903 773.133743,314.966799 777.724759,314.966799 C784.076712,314.966799 787.78726,316.81159 788.8564,320.501174 L788.8564,320.501174 L806.245659,320.501174 C805.910243,315.134507 803.326486,310.873667 798.494389,307.718653 C793.662292,304.56364 786.718119,302.986134 777.661868,302.986134 C768.165383,302.986134 760.775734,305.03532 755.492921,309.133693 C750.210109,313.232065 747.568702,319.358661 747.568702,327.513479 C747.568702,335.710224 750.241554,341.847302 755.587257,345.924711 C760.932961,350.00212 768.458873,352.040824 778.164993,352.040824 Z M827.807301,350.500004 L830.951833,343.299027 L854.410038,343.299027 L857.554569,350.500004 L873.717461,350.500004 L852.523319,304.526954 L832.964333,304.526954 L811.581519,350.500004 L827.807301,350.500004 Z M849.756131,332.60762 L835.605739,332.60762 L842.492263,316.884963 L842.869607,316.884963 L849.756131,332.60762 Z M893.329493,350.500004 L893.329493,317.985549 L893.706837,317.985549 L905.750393,350.500004 L917.479495,350.500004 L929.334379,318.488674 L929.711722,318.488674 L929.711722,350.500004 L944.522466,350.500004 L944.522466,304.526954 L920.561136,304.526954 L911.882229,331.381253 L911.504885,331.381253 L902.668752,304.526954 L879.210547,304.526954 L879.210547,350.500004 L893.329493,350.500004 Z M1000.61106,350.500004 L1000.61106,339.557035 L968.411061,339.557035 L968.411061,332.198831 L998.598563,332.198831 L998.598563,322.041994 L968.411061,322.041994 L968.411061,315.595705 L999.887821,315.595705 L999.887821,304.526954 L953.568873,304.526954 L953.568873,350.500004 L1000.61106,350.500004 Z M719.513602,411.540829 C728.54889,411.540829 735.608363,409.779891 740.692022,406.258016 C745.775681,402.73614 748.401365,397.673445 748.569073,391.069929 L748.569073,391.069929 L730.865361,391.069929 C730.508981,396.730085 726.725061,399.560164 719.513602,399.560164 C715.23704,399.560164 711.961486,398.454337 709.686942,396.242683 C707.412397,394.031029 706.275125,390.949388 706.275125,386.99776 C706.275125,383.046133 707.407156,379.969733 709.671219,377.768561 C711.935282,375.567389 715.216076,374.466803 719.513602,374.466803 C721.588993,374.466803 723.397099,374.713124 724.937919,375.205767 C726.47874,375.698411 727.657939,376.327317 728.475517,377.092486 C729.293095,377.857656 729.895797,378.638548 730.283623,379.435162 C730.671448,380.231777 730.907288,381.059837 730.991142,381.919342 L730.991142,381.919342 L748.443292,381.919342 C748.275584,375.777024 745.644659,371.002577 740.550518,367.596001 C735.456377,364.189426 728.444072,362.486138 719.513602,362.486138 C713.476102,362.486138 708.287625,363.350884 703.948172,365.080376 C699.608718,366.809868 696.202143,369.535129 693.728444,373.256158 C691.254746,376.977187 690.017897,381.562962 690.017897,387.013483 C690.017897,392.464004 691.254746,397.044538 693.728444,400.755086 C696.202143,404.465633 699.603477,407.190893 703.932449,408.930867 C708.261421,410.670841 713.455139,411.540829 719.513602,411.540829 Z M771.042629,410.000008 L771.042629,392.359187 L794.59517,392.296296 L794.59517,410.000008 L809.405913,410.000008 L809.405913,364.026958 L794.59517,364.026958 L794.59517,380.755865 L771.042629,380.755865 L771.042629,364.026958 L756.200441,364.026958 L756.200441,410.000008 L771.042629,410.000008 Z M831.156227,410.000008 L834.300759,402.799031 L857.758964,402.799031 L860.903495,410.000008 L877.066387,410.000008 L855.872245,364.026958 L836.313259,364.026958 L814.930445,410.000008 L831.156227,410.000008 Z M853.105057,392.107624 L838.954665,392.107624 L845.841189,376.384967 L846.218533,376.384967 L853.105057,392.107624 Z M896.74131,410.000008 L896.74131,381.73067 L897.118654,381.73067 L918.75303,410.000008 L935.764946,410.000008 L935.764946,364.026958 L921.677445,364.026958 L921.677445,391.698835 L921.268655,391.698835 L900.105959,364.026958 L882.559473,364.026958 L882.559473,410.000008 L896.74131,410.000008 Z M974.118386,411.540829 C981.812006,411.540829 987.744689,409.371102 991.916434,405.031648 L991.916434,405.031648 L991.916434,410.000008 L1002.38772,410.000008 L1002.38772,384.372077 L975.281862,384.372077 L975.281862,393.900007 L985.910379,393.900007 C985.910379,394.382169 985.705984,394.932462 985.297195,395.550886 C984.888406,396.169311 984.254259,396.834903 983.394754,397.547664 C982.535248,398.260424 981.298399,398.852644 979.684206,399.324324 C978.070014,399.796004 976.21474,400.031843 974.118386,400.031843 C969.317734,400.031843 965.727728,398.915535 963.348365,396.682917 C960.969003,394.4503 959.779322,391.227155 959.779322,387.013483 C959.779322,383.009446 960.94804,379.917324 963.285475,377.737115 C965.62291,375.556907 969.087135,374.466803 973.678151,374.466803 C980.030105,374.466803 983.740652,376.311594 984.809793,380.001178 L984.809793,380.001178 L1002.19905,380.001178 C1001.86363,374.634511 999.279878,370.373671 994.447782,367.218658 C989.615685,364.063644 982.671511,362.486138 973.615261,362.486138 C964.118776,362.486138 956.729127,364.535324 951.446314,368.633697 C946.163501,372.732069 943.522095,378.858665 943.522095,387.013483 C943.522095,395.210228 946.194946,401.347306 951.54065,405.424715 C956.886353,409.502124 964.412265,411.540829 974.118386,411.540829 Z M1058.16187,410.000008 L1058.16187,399.057039 L1025.96187,399.057039 L1025.96187,391.698835 L1056.14937,391.698835 L1056.14937,381.541998 L1025.96187,381.541998 L1025.96187,375.095709 L1057.43863,375.095709 L1057.43863,364.026958 L1011.11968,364.026958 L1011.11968,410.000008 L1058.16187,410.000008 Z"></path>
                  </g>
                </g>
              </svg>
            </h1>
            <h2>
              Three interactive stories from New Zealand's burgeoning video game
              industry
            </h2>
          </div>
          <ChooseCharacter text="Choose your character to begin" />
          <div className="characters">
            <Character
              story="gamePlan"
              id="gamePlan"
              face={Mike}
              title="Game Plan"
              tagline="The challenge to crack NZ’s gaming industry"
              number="01"
              link="/gameplan"
              playMouseOverAudio={this.playMouseOverAudio}
              playMouseOutAudio={this.playMouseOutAudio}
              playSelectAudio={this.playSelectAudio}
            />
            <Character
              story="gameFace"
              id="gameFace"
              face={Lorii}
              title="Game Face"
              tagline="The dual lives of one of our most successful video gamers"
              number="02"
              link="/gameface"
              playMouseOverAudio={this.playMouseOverAudio}
              playMouseOutAudio={this.playMouseOutAudio}
              playSelectAudio={this.playSelectAudio}
            />
            <Character
              story="gameOn"
              id="gameOn"
              face={Humphrey}
              title="Game On"
              tagline="The gamer with no hands and no excuses"
              number="03"
              link="/gameon"
              playMouseOverAudio={this.playMouseOverAudio}
              playMouseOutAudio={this.playMouseOutAudio}
              playSelectAudio={this.playSelectAudio}
            />
          </div>
          {!this.state.audioEnabled && (
            <div
              id="audio-prompt"
              onClick={() => this.controlPlayState(loopTrack)}
            >
              <div className="icon-bars">
                <div className="bar"></div>
                <div className="bar"></div>
                <div className="bar"></div>
              </div>
              <div className="label">Click to play audio</div>
            </div>
          )}
          <div className="bottom">
            <div className="links">
              <Link to="/videos">Videos</Link>
              <Link to="/about">About</Link>
            </div>
            <div className="accreditation">
              Made possible by the RNZ/NZ On Air Innovation Fund
            </div>
          </div>
        </div>
        {/* <JointFundLogo /> */}
      </div>
    );
  }
}

export default Landing;
